


































import { computed, defineComponent } from '@vue/composition-api';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
import { AudienceTagRelation } from '@tt4b/ttam-enums';
import ExpandImg from '@tt4b/ttam-assets/src/images/adgroup/audience_tag_expand.svg';
import NarrowImg from '@tt4b/ttam-assets/src/images/adgroup/audience_tag_narrow.svg';

const TagRelationOptions = [{
  name: 'module_adgroup_targeting_audience_retargeting_expand',
  value: AudienceTagRelation.UNION,
  desc: 'module_adgroup_targeting_audience_retargeting_expand_desc',
}, {
  name: 'module_adgroup_targeting_audience_retargeting_narrow',
  value: AudienceTagRelation.INTERSECTION,
  desc: 'module_adgroup_targeting_audience_retargeting_narrow_desc',
}]

const name = 'ttam-audience-tag-relation';
export default defineComponent({
  name,
  components: { QuestionTooltip, ExpandImg, NarrowImg },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },

  setup(props, { emit }) {
    const _customAudienceTagRelation = computed({
      get: () => props.value,
      set: val => {
        emit('change', val);
        emit('input', val);
      },
    });

    return {
      name,
      AudienceTagRelation,
      _customAudienceTagRelation,
      TagRelationOptions
    };
  },
});
